const USER_TOKEN_KEY = "concrete_user_token";
const COMPANY_TOKEN_KEY = "concrete_organization_token";
const COMPANY_ID = "concrete_organization_id";
const USER = "concrete_user";
const VERSION = "concrete_version";
const PLAN_STATUS = "concrete_plan_status"

export const getToken = () => {
    return window.localStorage.getItem(USER_TOKEN_KEY);
};

export const saveToken = token => {
    window.localStorage.setItem(USER_TOKEN_KEY, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(USER_TOKEN_KEY);
};

export const getOrganizationToken = () => {
    return window.localStorage.getItem(COMPANY_TOKEN_KEY);
};

export const saveOrganizationToken = token => {
    window.localStorage.setItem(COMPANY_TOKEN_KEY, token);
};

export const destroyOrganizationToken = () => {
    window.localStorage.removeItem(COMPANY_TOKEN_KEY);
};

export const getOrganizationId = () => {
    return window.localStorage.getItem(COMPANY_ID);
};

export const saveOrganizationId = organization_id => {
    window.localStorage.setItem(COMPANY_ID, organization_id);
};

export const destroyOrganizationId = () => {
    window.localStorage.removeItem(COMPANY_ID);
};

export const getUser = () => {
    return JSON.parse(window.localStorage.getItem(USER));
};

export const saveUser = user => {
    window.localStorage.setItem(USER, JSON.stringify(user));
};

export const destroyUser = () => {
    window.localStorage.removeItem(USER);
};

export const getVersion = () => {
    return window.localStorage.getItem(VERSION);
};

export const saveVersion = version => {
    window.localStorage.setItem(VERSION, version);
};

export const getPlanStatus = () => {
    return window.localStorage.getItem(PLAN_STATUS);
};

export const savePlanStatus = status => {
         window.localStorage.setItem(PLAN_STATUS, status);
       };

export default {
  getToken,
  saveToken,
  destroyToken,
  getOrganizationToken,
  saveOrganizationToken,
  destroyOrganizationToken,
  saveOrganizationId,
  getOrganizationId,
  destroyOrganizationId,
  getUser,
  saveUser,
  destroyUser,
  getVersion,
  saveVersion,
  getPlanStatus,
  savePlanStatus
};
